import React, { Component } from 'react';
import './ladda.min.css';

import { HashRouter } from 'react-router-dom';

import { Provider } from 'react-redux'

import { createStore, applyMiddleware } from 'redux';

import thunkMiddleware from 'redux-thunk';

import RootReducer from './reducers/RootReducer.js';

import RootPage from './routes/index.js';

const store = createStore(RootReducer, applyMiddleware(thunkMiddleware));


class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <HashRouter>
          <RootPage />
        </HashRouter>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js